module.exports = __webpack_public_path__ + "img/my-expenses-3.6fad8b45.svg";